import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2018 - 2023</p>
          <h2 className="text-3xl md:text-4xl font-bold">
            Education Background
          </h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Master of Computer Applications (MCA)"
            subTitle="Dravidian University, Kuppam (2023)"
            result="8.07 / 10"
            des="Postgraduate degree in Computer Applications with focus on programming, data structures, and software development."
          />
          <ResumeCard
            title="Bachelor of Science — Computer Science (B.Sc.)"
            subTitle="Sri Sai Baba National Degree College, Anantapur"
            result="7.01 / 10"
            des="Undergraduate program covering core computer science concepts including algorithms, databases, and web development."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Education;
